enum StorageEnum {
  Jwt = "jwt",
  Version = "Version",
  UserProfile = "userProfile",
  Usernames = "usernames",
  Market = "market",
  MarketComponents = "marketComponents",
  MarketComponentTypes = "marketComponentTypes",
  MarketComponentArticleTypes = "marketComponentArticleTypes",
}

export default StorageEnum;
